const protocol = "https";
const hostname = "bensburrito.com";

export const Configs = {
  locations: `${protocol}://${hostname}/locations`,
  categories: `${protocol}://${hostname}/categories`,
  items: `${protocol}://${hostname}/items`,
  ingredients: `${protocol}://${hostname}/ingredients`,
  extras: `${protocol}://${hostname}/extras`,
  banners: `${protocol}://${hostname}/banners`,
  waittime: `${protocol}://${hostname}/waittime`,

  businesshours: `${protocol}://${hostname}/businesshours`,

  tip: `${protocol}://${hostname}/tip`,

  specialdeal: `${protocol}://${hostname}/specialdeal`,
};
